import Label from './label';
import app from '../../public-api';

app.plugins.register({
  name: 'us:label',

  extends: 'viewport',

  dependencies: [
    'us:user-config',
    'us:settings:visibility-panel'
  ],

  constructor: Label
});
